import TagManager from 'react-gtm-module';

const GTM_ID = 'GTM-P526JJW';

export const initializeGtm = () => {
    const tagManagerArgs = {
        gtmId: GTM_ID
    }
    TagManager.initialize(tagManagerArgs);
}

export const pushToDataLayer = (dataLayer) => {

    TagManager.dataLayer({ dataLayer: dataLayer });
}


// WEBPACK FOOTER //
// ./src/utils/gtmUtils.js